import { Title, Subtitle, Bold, Body, Link } from '@panwds/react-ui'
import DividerLine from '../common/DividerLine'

import type { ComponentDef } from '../../renderer'
import type { ReactElement } from 'react'

export interface UAccordionProps {
  title: string
  subtitle?: string
  link?: string
  children: ComponentDef | ComponentDef[] | ReactElement | ReactElement[]
}
const UActivationSection = (props: UAccordionProps) => {
  const { title, subtitle, link, children } = props
  return (
    <div className='cm-justify-ceneter cm-mb-8'>
      <Title addClassName='cm-flex cm-capitalize' level={2} size={'sm'}>
        <Bold appearance='semibold'>{title}</Bold>
      </Title>
      <Subtitle>
        <Body addClassName='cm-pr-2' appearance='secondary' as='span'>{subtitle}</Body>
        {Boolean(link) && <Link href={link} external>Learn more</Link>}
      </Subtitle>
      <DividerLine />
      <div>
        {children}
      </div>
    </div>
  )
}

export default UActivationSection
